const guardarSelectedOrders = (selectedOrders) => {
    return {
        type: 'guardarSelectedOrders',
        payload: selectedOrders
    };
};

module.exports = {
    guardarSelectedOrders,
}